import React, { useState } from 'react';
import { useLocalizedText } from '../../../hooks/localizedText';
import { AutosuggestProps } from '@amzn/awsui-components-react';
import { loadCauseSuggestions } from '../../../hooks/causes';
import Autosuggest from '@amzn/awsui-components-react/polaris/autosuggest';

import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../../hooks/features';

// Constants for input validation
const MIN_CHARACTERS_FOR_AUTOCOMPLETE_INPUT = 2;
const MAX_CHARACTERS_FOR_AUTOCOMPLETE_INPUT = 180;

export interface CauseAutosuggestProps {
  currentCause: string;
  onChange: NonNullable<AutosuggestProps['onChange']>;
}

export function CauseAutosuggest({ currentCause, onChange }: CauseAutosuggestProps) {
  const namespaces = ['attendance', 'translation'];
  const { t } = useLocalizedText(namespaces);
  const [searchParams] = useSearchParams();
  const features = useFeatures();

  const [options, setOptions] = useState<AutosuggestProps.Options>([]);
  const [status, setStatus] = useState<AutosuggestProps.StatusType>();

  const loadCauseOptions = async (filteringText: string) => {
    //Cause autocomplete api only loads with 3+ characters and limit of 180 characters
    if (
      filteringText.length > MIN_CHARACTERS_FOR_AUTOCOMPLETE_INPUT &&
      filteringText.length <= MAX_CHARACTERS_FOR_AUTOCOMPLETE_INPUT
    ) {
      try {
        setStatus('loading');
        setOptions([]);
        const causeOptions = await loadCauseSuggestions(
          filteringText,
          getEnabledFeatures(features, searchParams)
        );
        setOptions(causeOptions);
        setStatus('finished');
      } catch (e) {
        setStatus('error');
      }
    } else {
      setOptions([]);
    }
  };

  return (
    <Autosuggest
      filteringType="manual"
      value={currentCause}
      onChange={(event) => {
        onChange(event);
      }}
      placeholder={t('additionalInfo.searchOrganizations')}
      statusType={status}
      options={(options ?? []).map((opt) => ({ value: opt.label ?? opt.value, label: opt.label }))}
      empty={t('additionalInfo.noCauseSuggestions')}
      loadingText={t('additionalInfo.loadingCauseSuggestions')}
      onLoadItems={({ detail }) => {
        loadCauseOptions(detail.filteringText);
      }}
    />
  );
}
